import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATH from 'routes/config';
import { requestApi } from 'utils/request';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import TextField from 'components/TextField';
import {
  FirstText,
  ChildText,
  ChildTextContent,
  BlueModifySection,
  BlueModifyText,
} from 'pages/DataLinkage/style';
import { DataLinkagePaddingWrapper } from '../../DataLinkageRequest/style';
import { COMMON_ERR_MESSAGE } from 'constants/message';
import { TAB_VALUES } from '../../DataLinkageManage/constants';
import CustomerFooter from 'components/CustomerFooter';

// 데이터 제공사를 통한 데이터 연동 수정
const DataProviderModifyPage = ({
  dataProviderSeq,
  setContextLoading,
  setModalData,
}) => {
  const navigate = useNavigate();
  const [dataProviderInfo, setDataProviderInfo] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(true);

  const {
    dataProviderId = '',
    dataProviderPassword = '',
    dataProviderName = '',
    businessRegistrationNumber = '',
  } = dataProviderInfo;

  // input 데이터 변경
  const onChangeTextField = event => {
    const { name, value } = event.target;
    setDataProviderInfo(prev => ({ ...prev, [name]: value }));
  };

  // 판매몰 계정 확인 버튼 클릭시
  const onClickModifyButton = () => {
    (async () => {
      await fetchDataProviderUpdate();
    })();
  };

  // 데이터제공사 상세 조회 api
  const fetchDataProviderGet = async () => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider/${dataProviderSeq}/interlock/business`,
        method: 'GET',
      });
      setDataProviderInfo({
        ...res.data.result,
        dataProviderPassword: res.data.result.dataProviderPassword,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setContextLoading(false);
    }
  };

  // 데이터제공사 연동 수정 api
  const fetchDataProviderUpdate = async () => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider/${dataProviderSeq}/interlock/business`,
        method: 'PUT',
        data: {
          dataProviderId: dataProviderId,
          dataProviderPassword: dataProviderPassword,
        },
      });

      setModalData({
        contents: res.message,
        confirmBtnName: '데이터 연동 관리',
        onClickConfirmBtn: () => {
          navigate(ROUTE_PATH.mypage.dataLinkageManage, {
            state: {
              tabValue: TAB_VALUES.DATA_PROVIDER,
            },
          });
        },
        cancelBtnName: '닫기',
        onClickCancelBtn: () => {
          window.location.reload();
        },
      });
    } catch (error) {
      console.error(error);
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
    }
  };

  useEffect(() => {
    (async () => {
      await fetchDataProviderGet();
    })();
  }, []);

  return (
    <DataLinkagePaddingWrapper>
      <div className="wrapBox">
        <FirstText>
          데이터 제공사 정보 수정이 필요한 경우
          <br />
          수정하기를 눌러주세요.
        </FirstText>
        <ChildText>
          <ChildTextContent>사업자 번호</ChildTextContent>
          <ChildTextContent>{businessRegistrationNumber}</ChildTextContent>
        </ChildText>
        <ChildText>
          <ChildTextContent>연동 정보</ChildTextContent>
          <ChildTextContent>데이터 제공사 연동</ChildTextContent>
        </ChildText>
        <TextField
          name="name"
          placeholder="이름"
          readOnly
          value={dataProviderName}
          style={{ margin: 0 }}
        />
        <BlueModifySection>
          <BlueModifyText onClick={() => setIsReadOnly(false)}>
            계정 정보 수정하기
          </BlueModifyText>
        </BlueModifySection>
        <TextField
          style={{ margin: 0 }}
          name="dataProviderId"
          placeholder="아이디"
          type="text"
          value={dataProviderId}
          readOnly={isReadOnly}
          onChange={onChangeTextField}
        />
        <TextField
          name="dataProviderPassword"
          placeholder="비밀번호"
          type="password"
          value={dataProviderPassword}
          readOnly={isReadOnly}
          onChange={onChangeTextField}
        />

        {!isReadOnly && (
          <StyledActiveButton
            disabled={!dataProviderPassword || !dataProviderId}
            onClick={onClickModifyButton}
          >
            데이터 연동 요청
          </StyledActiveButton>
        )}
      </div>
      <CustomerFooter />
    </DataLinkagePaddingWrapper>
  );
};

export default DataProviderModifyPage;
